import { Organisation } from "@sso/types";

import { AddressKeys } from "./address";

export enum OrganisationIds {
  BASEMAP,
}

export enum OrganisationKeys {
  ID = "organisationId",
  NAME = "name",
  BILLING_EMAIL = "billingEmail",
  PHONE = "phone",
  VAT_NUMBER = "vatNumber",
  USER_COUNT = "userCounts",
  CREATED = "creationDate",
  LAST_LOGIN = "lastLoginDate",
  ADDRESS = "address",
  ADDRESS_ID = "addressId",
  TRANSACTION_CURRENCY_CODE = "transactionCurrencyCode",
  TRANSACTION_CURRENCY = "transactionCurrency",
  PRODUCTS = "products",
}

export enum OrganisationSignUpKeys {
  NAME = "organisationName",
  BILLING_ADDRESS = "organisationBillingAddress",
  BILLING_EMAIL = "organisationBillingEmail",
  PHONE = "organisationPhone",
  VAT_NUMBER = "organisationVatNumber",
  ORGANISATION_TRANSACTION_CURRENCY_CODE = "organisationTransactionCurrencyCode",
  ADDRESS = "address",
}

export enum BillingAddressSignUpKeys {
  FIRST_LINE = "firstLine",
  SECOND_LINE = "secondLine",
  CITY = "city",
  STATE = "state",
  POSTCODE = "postcode",
  COUNTRY_ID = "countryId",
  COUNTRY = "country",
}

export const organisationInitialValues: Organisation = {
  [OrganisationKeys.ID]: -1,
  [OrganisationKeys.NAME]: "",
  [OrganisationKeys.BILLING_EMAIL]: "",
  [OrganisationKeys.PHONE]: "",
  [OrganisationKeys.VAT_NUMBER]: "",
  [OrganisationKeys.ADDRESS_ID]: "",
  [OrganisationKeys.TRANSACTION_CURRENCY_CODE]: "",
  [OrganisationKeys.ADDRESS]: {
    [AddressKeys.ID]: "",
    [AddressKeys.FIRST_LINE]: "",
    [AddressKeys.SECOND_LINE]: "",
    [AddressKeys.CITY]: "",
    [AddressKeys.STATE]: "",
    [AddressKeys.POSTCODE]: "",
    [AddressKeys.COUNTRY_ID]: "",
    [AddressKeys.COUNTRY]: {},
  },
};
